import { useNotification as useNotificationContext } from '../context/NotificationContext';

export const useNotification = () => {
  const { notification, showNotification, hideNotification } = useNotificationContext();

  const showSuccess = (message, button1 = null, button2 = null, duration = 0) => {
    showNotification({
      message,
      button1: button1
        ? {
            text: button1.text || 'OK',
            onClick: button1.onClick,
            closeOnClick: button1.closeOnClick,
            style: button1.style,
            icon: button1.icon,
          }
        : null,
      button2: button2
        ? {
            text: button2.text || 'Cancel',
            onClick: button2.onClick,
            closeOnClick: button2.closeOnClick,
            style: button2.style,
            icon: button2.icon,
          }
        : null,
      duration,
    });
  };

  const showError = (message, button1 = null, button2 = null, duration = 0) => {
    showNotification({
      message,
      button1: button1
        ? {
            text: button1.text || 'OK',
            onClick: button1.onClick,
            closeOnClick: button1.closeOnClick,
            style: button1.style,
          }
        : null,
      button2: button2
        ? {
            text: button2.text || 'Cancel',
            onClick: button2.onClick,
            closeOnClick: button2.closeOnClick,
            style: button2.style,
          }
        : null,
      duration,
    });
  };

  const showConfirm = (
    message,
    onConfirm,
    onCancel = null,
    confirmText = 'Confirm',
    cancelText = 'Cancel'
  ) => {
    showNotification({
      message,
      button1: {
        text: confirmText,
        onClick: onConfirm,
        closeOnClick: true,
        style: { backgroundColor: '#ffd136', color: 'black' },
      },
      button2: {
        text: cancelText,
        onClick: onCancel || hideNotification,
        closeOnClick: true,
        style: { backgroundColor: '#f5f5f5', color: '#666' },
      },
      duration: 0,
    });
  };

  const showDeleteConfirm = (message, onConfirm, onCancel = null) => {
    showNotification({
      message,
      button1: {
        text: 'Delete',
        onClick: onConfirm,
        closeOnClick: true,
        style: { backgroundColor: '#f44336', color: 'white' },
      },
      button2: {
        text: 'Cancel',
        onClick: onCancel || hideNotification,
        closeOnClick: true,
        style: { backgroundColor: 'white', color: '#ffd136', border: '2px solid #ffd136' },
      },
      duration: 0,
    });
  };

  return {
    notification,
    showNotification,
    showSuccess,
    showError,
    showConfirm,
    showDeleteConfirm,
    hideNotification,
  };
};
